import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Offcanvas, Form, Navbar, Nav } from "react-bootstrap";
import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";
import { APK_LS_KEY, AuthModals } from "../config/const";
import useAuthModalHook from "../hooks/useAuthModalHook";

import StaticLogo from "../assets/images/staticlogo.png";
import EyeIcon from "../assets/svg/EyeIcon";
import logo from "../assets/images/logo.webp";
import APK from "../assets/images/android.png";
import Sports from "../assets/images/icons/head-menu/sports.svg";
import LiveCasino from "../assets/images/icons/head-menu/live-casino.svg";
import Casino from "../assets/images/icons/head-menu/casino.svg";
import Promotion from "../assets/images/icons/head-menu/promotion.svg";
import MenuToggle from "../assets/images/icons/menuLeft.svg";
import LeftMenuBar from "./LeftMenuBar";
import ThemeToggle from "./ThemeToggle";

const Header = () => {
  const { updateActiveAuthModal } = useAuthModalHook();
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [isLanguageShow, setIsLanguageShow] = useState(true);
  const [showNotifications, setShowNotifications] = useState(true);
  const [showLeftbar, setShowLeftbar] = useState(false);
  const navigate = useNavigate();
  const { appDetails } = useSelector((state) => state.app);
  const isApkEnv = localStorage.getItem(APK_LS_KEY) === "true";

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  useEffect(() => {
    loadNotifications();
  }, []);

  const checkIfActive = (url) => {
    const path = window?.location?.pathname;
    return path?.indexOf(url) > -1 ? "active" : "";
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }}>{notf?.content}</label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}
      <header className="header beforeheader">
        <div className="top_head">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <div className="leftbar-toggle me-3 d-lg-none">
                      <Button onClick={() => setShowLeftbar(true)}>
                        <img src={MenuToggle} alt="menu toggle" />
                      </Button>
                    </div>
                    <div className="logo">
                      <a href="/">
                        {/* <img src={appDetails?.LOGO_URL} alt="Logo" /> */}
                        <img src={logo} alt="Logo" />
                      </a>
                    </div>
                  </div>
                  <div className="staticLogo">
                    <img src={StaticLogo} />
                  </div>
                  <div className="middle-part">
                    <Navbar expand="lg" className="d-none d-lg-block">
                      {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
                      <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                          <Nav.Link
                            href="/live-casino"
                            className={checkIfActive("/live-casino")}
                          >
                            <img src={LiveCasino} alt="bottom head link icon" />
                            <span>Live Casino</span>
                          </Nav.Link>
                          <Nav.Link
                            href="/casino"
                            className={checkIfActive("/casino")}
                          >
                            <img src={Casino} alt="bottom head link icon" />
                            <span>Virtual Casino</span>
                          </Nav.Link>
                          <Nav.Link
                            href="/sportsbook"
                            className={checkIfActive("/sportsbook")}
                          >
                            <img src={Sports} alt="Sportsbook" />
                            <span>Sportsbook</span>
                          </Nav.Link>
                          <Nav.Link
                            href="/sports/Cricket"
                            className={checkIfActive("/sports/Cricket")}
                          >
                            <img src={Sports} alt="Exchange Icon" width={20} />
                            Exchange
                          </Nav.Link>
                          {/* <Nav.Link href="/sign-in">
                            <img src={Promotion} alt="bottom head link icon" />
                            <span>Promotions</span>
                          </Nav.Link> */}
                        </Nav>
                      </Navbar.Collapse>
                    </Navbar>
                  </div>
                  <div className="headerRight">
                    <ThemeToggle />

                    {!isApkEnv ? (
                      <a
                        href="https://dl.dropbox.com/scl/fi/cg2e1je1c91795b43bdya/Prada365.apk?rlkey=9o6q84wpi7jwlvjxa8vjxc2xp&st=nud6p5xw&dl=0"
                        download="https://dl.dropbox.com/scl/fi/cg2e1je1c91795b43bdya/Prada365.apk?rlkey=9o6q84wpi7jwlvjxa8vjxc2xp&st=nud6p5xw&dl=0"
                      >
                        <img
                          src={APK}
                          alt="Calling icon"
                          style={{ width: "30px", margin: "8px" }}
                        />
                      </a>
                    ) : null}
                    <Button
                      variant="primary"
                      onClick={() => {
                        // navigate("/sign-in");
                        updateActiveAuthModal(AuthModals.Login);
                      }}
                      className="button-primary btn_signin"
                    >
                      Login
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() => {
                        // navigate("/mobile-number");
                        updateActiveAuthModal(AuthModals.MobileNumber);
                      }}
                      className="button-primary btn_signup"
                    >
                      Join Now
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* <Offcanvas
          className={"steps-canvas"}
          show={show}
          onHide={handleClose}
          placement={"end"}
        >
          <Offcanvas.Header closeButton="closeButton" closeVariant="white">
            <Offcanvas.Title>
              <span className="top-heading">Sign in now!</span>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="form-steps">
              <h2 className="h2">Hello Again!</h2>
              <p>
                Welcome back, you've
                <br />
                been missed!
              </p>
              <Form>
                <Form.Group className="mb-3" controlId="formBasicName">
                  <Form.Control type="text" placeholder="Enter Username*" />
                </Form.Group>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control type="password" placeholder="Password*" />
                  <span className="icon">
                    <EyeIcon />
                  </span>
                </Form.Group>
                <div className="d-flex justify-content-end mb-3">
                  <a className="form-link" href="#">
                    Password Recovery
                  </a>
                </div>
                <Button variant="primary" type="submit">
                  Sign in
                </Button>
              </Form>
              <div className="sign-up mt-4">
                Not a member?
                <br />
                <a href="register">Sign Up Now</a>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas> */}
      </header>

      <LeftMenuBar show={showLeftbar} onClose={() => setShowLeftbar(false)} />
    </>
  );
};

export default Header;
